import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from './views/layouts/Main.vue'
import Login from './views/Login.vue'
import Home from './views/Home.vue'

import Module from './views/module/Module.vue'
import NewModule from './views/module/NewModule.vue'
import EditModule from './views/module/EditModule.vue'

import EditPage from './views/page/EditPage.vue'
import Pages from './views/page/Pages.vue'
import NewPage from './views/page/NewPage.vue'

import Categories from './views/category/Categories.vue'
import EditCategory from './views/category/EditCategory.vue'
import NewCategory from './views/category/NewCategory.vue'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			component: MainLayout,
			meta: {
				auth: true,
			},
			children: [
				{
					path: '',
					name: 'home',
					component: Home,
				},
				{
					path: '/app/:name',
					name: 'module',
					component: Module,
				},
				{
					path: '/app/:name/new',
					name: 'new',
					component: NewModule,
				},
				{
					path: '/app/:name/edit/:id',
					name: 'edit',
					component: EditModule,
				},
				{
					path: '/pages/:id/edit',
					name: 'edit-page',
					component: EditPage,
				},
				{
					path: '/pages',
					name: 'pages',
					component: Pages,
				},
				{
					path: 'pages/new',
					name: 'new-page',
					component: NewPage,
				},
				{
					path: 'categories',
					name: 'categories',
					component: Categories,
				},
				{
					path: 'categories/:id/edit',
					name: 'edit-category',
					component: EditCategory,
				},
				{
					path: 'categories/new',
					name: 'new-category',
					component: NewCategory,
				},
				// add catching error here
			],
		},
		{
			path: '/login',
			name: 'login',
			component: Login,
		},
		{
			path: '/about',
			name: 'about',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
		},
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
})

router.beforeEach((to, from, next) => {
	if (to.matched.some((record) => record.meta.auth)) {
		if (!localStorage.authKey) {
			next({
				path: '/login',
			})
		} else {
			next()
		}
	} else {
		next() // make sure to always call next()!
	}
})

export default router
